export const objectDrawer = {
  Staging_for_loading: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Storage",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Dimension",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Total Area (M2)",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Start Date",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End Date",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "date2",
        key: "date2",
        type: "date",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
    ],
  },
  Stacking_using_crane: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Date",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "No Truck",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Shiping Manifest",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Package",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Weight (kg)",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },

      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "text",
      },
      {
        name: "form6",
        key: "form6",
        type: "text",
      },
    ],
  },
  Stacking_using_forklift: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Date",
        colSpan: 1,
        rowSpan: 1,
      },
      // {
      //   text: "Keterangan",
      //   colSpan: 1,
      //   rowSpan: 1,
      // },
      {
        text: "No Truck",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Shiping Manifest",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Package",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Weight (Kg)",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      // {
      //   name: "form7",
      //   key: "form7",
      //   type: "text",
      // },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },

      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "text",
      },
      {
        name: "form6",
        key: "form6",
        type: "text",
      },
    ],
  },
  Stuffing: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Deskripsi Waste",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Tanggal",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Quantity",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Total (kg)",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Loading",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Loading (kg)",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },

      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "text",
      },
    ],
  },
  Bundling: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Quantity /Package",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Shipping Manifest",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Material",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Package",
        colSpan: 1,
        rowSpan: 1,
      },
      // {
      //   text: "Unloading (kg)",
      //   colSpan: 1,
      //   rowSpan: 1,
      // },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Total (kg)",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form2",
        key: "form2",
        type: "number",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },

      // {
      //   name: "form4",
      //   key: "form4",
      //   type: "text",
      // },
      {
        name: "form5",
        key: "form5",
        type: "number",
      },
      {
        name: "form6",
        key: "form6",
        type: "number",
      },
      {
        name: "form7",
        key: "form7",
        type: "number",
      },
      {
        name: "form8",
        key: "form8",
        type: "text",
      },
    ],
  },
  Vessel_Service: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Jetty",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Vessel Name",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Time",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Activity", // Ganti dari "Type" menjadi "Activity"
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Total Hours",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Arrival",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Departure",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "Jetty",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "date1",
        key: "date1",
        type: "dateTime",
      },
      {
        name: "date2",
        key: "date2",
        type: "dateTime",
      },
      {
        name: "form5", // Activity Type (Standby/Loading/Unloading)
        key: "form5",
        type: "SBerthing",
      },
      {
        name: "form4", // Total Hours
        key: "form4",
        type: "TBerthing",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
    ],
  },
  Vessel_Berthing: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Jetty",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Vessel Name",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Time",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Activity", // Ganti dari "Type" menjadi "Activity"
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Total Hours",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Arrival",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Departure",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "Jetty",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "date1",
        key: "date1",
        type: "dateTime",
      },
      {
        name: "date2",
        key: "date2",
        type: "dateTime",
      },
      {
        name: "form5", // Activity Type (Standby/Loading/Unloading)
        key: "form5",
        type: "SBerthing",
      },
      {
        name: "form4", // Total Hours
        key: "form4",
        type: "TBerthing",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
    ],
  },
  Liquid: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Material Descriptions",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Berthing Date",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Vessel / Facility Name",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Flow Meter ",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Total",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Start ",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End ",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "",
        key: "",
        type: "TotalFuel",
      },
      {
        name: "form5",
        key: "form5",
        type: "Oum",
      },
      {
        name: "form6",
        key: "form6",
        type: "text",
      },
    ],
  },
  Port_Service_Common: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Material Descriptions",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Type of Packaging",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Operation Type",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "form2",
        key: "form2",
        type: "PackagePort",
      },
      {
        name: "form3",
        key: "form3",
        type: "OperationType",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "Oum",
      },
      {
        name: "form8",
        key: "form8",
        type: "text",
      },
    ],
  },
  Cargodoring: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Material Descriptions",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Type of Packaging",
        colSpan: 1,
        rowSpan: 1,
      },
      // {
      //   text: "UoM",
      //   colSpan: 1,
      //   rowSpan: 1,
      // },
      {
        text: "Loading Quantity",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 1,
      },
      // {
      //   text: "Unloading Quantity",
      //   colSpan: 1,
      //   rowSpan: 1,
      // },
      // {
      //   text: "UoM",
      //   colSpan: 1,
      //   rowSpan: 1,
      // },
      // {
      //   text: "Start Time",
      //   colSpan: 1,
      //   rowSpan: 1,
      // },
      // {
      //   text: "Finish Time",
      //   colSpan: 1,
      //   rowSpan: 1,
      // },
      {
        text: "Destination",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "form2",
        key: "form2",
        type: "PackagePort",
      },
      // {
      //   name: "form3",
      //   key: "form3",
      //   type: "Oum",
      // },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "Oum",
      },
      // {
      //   name: "form6",
      //   key: "form6",
      //   type: "text",
      // },
      // {
      //   name: "form7",
      //   key: "form7",
      //   type: "Oum",
      // },
      // {
      //   name: "date1",
      //   key: "date1",
      //   type: "time",
      // },
      // {
      //   name: "date2",
      //   key: "date2",
      //   type: "time",
      // },
      {
        name: "form6",
        key: "form6",
        type: "Distenation",
      },
      {
        name: "form7",
        key: "form7",
        type: "text",
      },
    ],
  },
  Port_Service_External: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Material Descriptions",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Type of Package",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 1,
      },

      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "form2",
        key: "form2",
        type: "PackagePort",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "Oum",
      },

      {
        name: "form6",
        key: "form6",
        type: "text",
      },
    ],
  },

  Port_Service_External: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Material Descriptions",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Type of Package",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 1,
      },

      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "form2",
        key: "form2",
        type: "PackagePort",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "Oum",
      },

      {
        name: "form6",
        key: "form6",
        type: "text",
      },
    ],
  },
  Bulk_Transfer: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Material Descriptions",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Berthing Date",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Vessel Name",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Flow Meter ",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Total",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Start ",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End ",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "text",
      },
      {
        name: "date1",
        key: "date1",
        type: "dateTime",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "",
        key: "",
        type: "TotalFuel",
      },
      {
        name: "form5",
        key: "form5",
        type: "Oum",
      },
      {
        name: "form6",
        key: "form6",
        type: "text",
      },
    ],
  },
  RENTAL: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Descriptions",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Detail Unit",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Unit Number",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Date / Time ",
        colSpan: 2,
        rowSpan: 1,
      },

      {
        text: "Total",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Start ",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End ",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "kelompokKendaraan",
      },

      {
        name: "form2",
        key: "form2",
        type: "SelectorKendaraan",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "form6",
        key: "form6",
        type: "number",
      },
      {
        name: "form4",
        key: "form4",
        type: "OumRental",
      },
      {
        name: "date1",
        key: "date1",
        type: "dateTime",
      },
      {
        name: "date2",
        key: "date2",
        type: "dateTime",
      },
      {
        name: "form7",
        key: "form7",
        type: "TimeRental",
      },
      {
        name: "form5",
        key: "form5",
        type: "text",
      },
    ],
  },
  AREA_RENTAL: {
    header_upper: [
      { text: "", colSpan: 1, rowSpan: 2 },
      { text: "Description", colSpan: 1, rowSpan: 2 },
      { text: "Qty", colSpan: 1, rowSpan: 2 },
      { text: "UoM", colSpan: 1, rowSpan: 2 },
      { text: "Storage Date", colSpan: 2, rowSpan: 1 },
      { text: "Total Days", colSpan: 1, rowSpan: 2 },
      { text: "Length", colSpan: 1, rowSpan: 2 },
      { text: "Wide", colSpan: 1, rowSpan: 2 },
      { text: "Height", colSpan: 1, rowSpan: 2 },
      { text: "Total Dimension", colSpan: 1, rowSpan: 2 },
      { text: "Dim UoM", colSpan: 1, rowSpan: 2 },
      { text: "Total Rental", colSpan: 1, rowSpan: 2 },
      { text: "Remarks", colSpan: 1, rowSpan: 2 },
    ],

    header: [
      { text: "Start", colSpan: 1, rowSpan: 1 },
      { text: "End", colSpan: 1, rowSpan: 1 },
    ],

    body: [
      { name: "button", key: "", type: "button" },
      { name: "form1", key: "form1", type: "Selector" }, // Description
      { name: "form2", key: "form2", type: "number" }, // Qty
      { name: "form3", key: "form3", type: "Oum" }, // Qty UoM
      { name: "date1", key: "date1", type: "date" }, // Start
      { name: "date2", key: "date2", type: "date" }, // End
      { name: "", key: "", type: "totalDays" }, // Total Days
      { name: "form4", key: "form4", type: "number" }, // Length
      { name: "form5", key: "form5", type: "number" }, // Wide
      { name: "form6", key: "form6", type: "number" }, // Height
      { name: "", key: "", type: "TDimension" }, // Total Dimension
      { name: "form7", key: "form7", type: "Oum" }, // Dimension UoM
      { name: "", key: "", type: "TArarental" }, // Total Rental
      { name: "form8", key: "form8", type: "text" }, // Remarks
    ],
  },

  MANPOWER: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Descriptions",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Working Date",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Working Time",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Total Hour",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Total Manpower",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Total",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Start ",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End ",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Start ",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End ",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },

      {
        name: "form1",
        key: "form1",
        type: "Selector",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "date2",
        key: "date2",
        type: "date",
      },
      {
        name: "date3",
        key: "date3",
        type: "time",
      },
      {
        name: "date4",
        key: "date4",
        type: "time",
      },
      {
        name: "form5",
        key: "form5",
        type: "number",
      },
      {
        name: "form2",
        key: "form2",
        type: "number",
      },
      {
        name: "",
        key: "",
        type: "totalManpowerValue",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
    ],
  },
  WASTE_MANAGEMENT_SERVICES: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      // {
      //   text: "Descriptions",
      //   colSpan: 1,
      //   rowSpan: 2,
      // },
      {
        text: "Haz. Waste Code",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Waste Description",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Packaging Number",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Type Of Packaging",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      // {
      //   name: "form1",
      //   key: "form1",
      //   type: "SelectorWSM",
      // },
      {
        name: "form8",
        key: "form8",
        type: "Limbah1",
      },
      {
        name: "form8",
        key: "form8",
        type: "Limbah2",
      },

      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "PackageWSM",
      },
      {
        name: "form4",
        key: "form4",
        type: "Oum",
      },
      {
        name: "form5",
        key: "form5",
        type: "number",
      },
      {
        name: "form6",
        key: "form6",
        type: "Oum",
      },
      {
        name: "form7",
        key: "form7",
        type: "text",
      },
    ],
  },
  ROOM: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Room Number",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Person",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Date",
        colSpan: 2,
        rowSpan: 1,
      },

      {
        text: "Total Day",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Name",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Company",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Sponsor Company",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Start",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "Selector",
      },
      {
        name: "form6",
        key: "form6",
        type: "number",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "date2",
        key: "date2",
        type: "date",
      },

      {
        name: "form7",
        key: "form7",
        type: "totalDays2",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "text",
      },
    ],
  },
  MEALS: {
    header_upper: [
      {
        text: "No.",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Descriptions",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Qty",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Date",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Total Meal",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Name",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Company",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Sponsor Company",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],

    header: [],

    body: [
      {
        name: "no",
        key: "",
        type: "numbering",  // type baru untuk nomor urut
      },
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "Selector",
      },
      {
        name: "form6",
        key: "form6",
        type: "number",
      },
      {
        name: "form7",
        key: "form7",
        type: "OumMeals",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "",
        key: "",
        type: "TMeal",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "text",
      },
    ],
  },
  LAUNDRY: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Type Of Cloth",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Weight",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "OuM",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Tanggal",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Name",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Company",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Sponsor Company",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "TypeOfCloth",
      },
      {
        name: "form6",
        key: "form6",
        type: "number",
      },
      {
        name: "form7",
        key: "form7",
        type: "Oum",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },

      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
      {
        name: "form5",
        key: "form5",
        type: "text",
      },
    ],
  },
  WOODEN: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Descriptions",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Location Used",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Date",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Total",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Start",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "Selector",
      },
      {
        name: "form2",
        key: "form2",
        type: "LocationUsed",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "date2",
        key: "date2",
        type: "date",
      },
      {
        name: "",
        key: "",
        type: "totalTime",
      },
      {
        name: "form3",
        key: "form3",
        type: "number",
      },
      {
        name: "form4",
        key: "form4",
        type: "Oum",
      },

      {
        name: "form5",
        key: "form5",
        type: "text",
      },
    ],
  },
  Vehicle: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Detail Unit",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Unit Number",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Date",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Day",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Total",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Start",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "Selector",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "number",
      },
      {
        name: "form4",
        key: "form4",
        type: "Oum",
      },

      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "date2",
        key: "date2",
        type: "date",
      },
      {
        name: "",
        key: "",
        type: "totalDays",
      },
      {
        name: "",
        key: "",
        type: "totalVehicle",
      },

      {
        name: "form5",
        key: "form5",
        type: "text",
      },
    ],
  },
  Fuel: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Date",
        colSpan: 1,
        rowSpan: 1,
      },

      {
        text: "Fuel Description",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "User",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Sponsor Company",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Flow Meter (Start)",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Flow Meter (End)",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Total",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "date1",
        key: "date1",
        type: "date",
      },
      {
        name: "form1",
        key: "form1",
        type: "Feul",
      },
      {
        name: "form7",
        key: "form7",
        type: "text",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "number",
      },
      {
        name: "form4",
        key: "form4",
        type: "number",
      },
      {
        name: "",
        key: "",
        type: "TotalFuel",
      },
      {
        name: "form5",
        key: "form5",
        type: "Oum",
      },

      {
        name: "form6",
        key: "form6",
        type: "text",
      },
    ],
  },
  "Clearance Doc": {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Document Number",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Document Name",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Quantity",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "form4",
        key: "form4",
        type: "number",
      },

      {
        name: "form5",
        key: "form5",
        type: "text",
      },
    ],
  },

  Material_Supply: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Date",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Deskripsi Barang",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Qty",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "UoM",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "date1",
        key: "date1",
        type: "dateTime",
      },
      {
        name: "form1",
        key: "form1",
        type: "Selector",
      },
      {
        name: "form2",
        key: "form2",
        type: "number",
      },
      {
        name: "form3",
        key: "form3",
        type: "Oum",
      },
      {
        name: "form4",
        key: "form4",
        type: "text",
      },
    ],
  },
  Drill: {
    header_upper: [
      {
        text: "",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Description",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Date",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Total Time",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "User",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Sponsor Company",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Flow Meter",
        colSpan: 2,
        rowSpan: 1,
      },
      {
        text: "Total",
        colSpan: 1,
        rowSpan: 2,
      },

      {
        text: "Uom",
        colSpan: 1,
        rowSpan: 2,
      },
      {
        text: "Remarks",
        colSpan: 1,
        rowSpan: 2,
      },
    ],
    header: [
      {
        text: "Start Arrival",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End Departure",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "Start",
        colSpan: 1,
        rowSpan: 1,
      },
      {
        text: "End",
        colSpan: 1,
        rowSpan: 1,
      },
    ],
    body: [
      {
        name: "button",
        key: "",
        type: "button",
      },
      {
        name: "form1",
        key: "form1",
        type: "Selector",
      },
      {
        name: "date1",
        key: "date1",
        type: "dateTime",
      },
      {
        name: "date2",
        key: "date2",
        type: "dateTime",
      },
      {
        name: "",
        key: "",
        type: "totalTime",
      },
      {
        name: "form2",
        key: "form2",
        type: "text",
      },
      {
        name: "form3",
        key: "form3",
        type: "text",
      },
      {
        name: "form4",
        key: "form4",
        type: "number",
      },
      {
        name: "form5",
        key: "form5",
        type: "number",
      },
      {
        name: "",
        key: "",
        type: "totalDrill",
      },
      {
        name: "form6",
        key: "form6",
        type: "Oum",
      },
      {
        name: "form7",
        key: "form7",
        type: "text",
      },
    ],
  },
};

export function initBuilderOutput() {}

export function filterObjectViewer(obj, val) {
  const result = obj.filter((item) => {
    return item.value === val;
  })[0];
  if (result) {
    return result.label;
  } else {
    return "";
  }
}

export const orderVessel = {
  Vessel_Berthing: 1,
  Stevedoring: 2,
  Cargodoring: 3,
  Receiving: 4,
  Delivery: 5,
  Stacking_atau_Restacking: 6,
  Bulk_Transfer: 7,
  Liquid: 8,
  Receiving_Using_Forklift: 9,
  Receiving_Using_Crane: 10,
  Delivery_Using_Forklift: 11,
  Delivery_Using_Crane: 12,
};

export function SortingPORT_Services(tempdata) {
  if (
    tempdata[0]["Name"] === "PORT_SERVICES" &&
    tempdata[0]["DetailActivity"]
  ) {
    tempdata[0]["DetailActivity"].sort(
      (a, b) =>
        (orderVessel[a.Name] || Number.MAX_VALUE) -
        (orderVessel[b.Name] || Number.MAX_VALUE),
    );
  }
  return tempdata;
}
